import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, Package, DollarSign, FileText, TrendingUp, BarChart3, Wallet, ClipboardList, LogOut, RefreshCw, LayoutDashboard, Phone, CreditCard, PieChart, UserCog, Award, Video, Settings, Menu, X, Tag, KeyRound, Boxes, ShoppingBag, MessageSquare, Film, Flame, Globe } from 'lucide-react';
import { Button } from '../components/ui/button';
import UsersManagement from '../components/admin/UsersManagement';
import OrdersManagement from '../components/admin/OrdersManagement';
import PaymentsManagement from '../components/admin/PaymentsManagement';
import UTRManagement from '../components/admin/UTRManagement';
import AdsManagement from '../components/admin/AdsManagement';
import AnalyticsManagement from '../components/admin/AnalyticsManagement';
import EarningsManagement from '../components/admin/EarningsManagement';
import OnboardingManagement from '../components/admin/OnboardingManagement';
import AdminOverview from '../components/admin/AdminOverview';
import ContactRequestsManagement from '../components/admin/ContactRequestsManagement';
import PaymentSettingsManagement from '../components/admin/PaymentSettingsManagement';
import PageAnalyticsManagement from '../components/admin/PageAnalyticsManagement';
import SalesAgentsManagement from '../components/admin/SalesAgentsManagement';
import SalesShowcaseManagement from '../components/admin/SalesShowcaseManagement';
import TrustBadgesManagement from '../components/admin/TrustBadgesManagement';
import MetricsSettings from '../components/admin/MetricsSettings';
import PackageSettings from '../components/admin/PackageSettings';
import CRMManagement from '../components/admin/CRMManagement';
import CouponsManagement from '../components/admin/CouponsManagement';
import PasswordResetsManagement from '../components/admin/PasswordResetsManagement';
import ProductsCatalogManagement from '../components/admin/ProductsCatalogManagement';
import ClientOnboardingManagement from '../components/admin/ClientOnboardingManagement';
import SiteVideosManagement from '../components/admin/SiteVideosManagement';
import WalletManagement from '../components/admin/WalletManagement';
import ReviewsManagement from '../components/admin/ReviewsManagement';
import ReelsManagement from '../components/admin/ReelsManagement';
import AdsPaymentsManagement from '../components/admin/AdsPaymentsManagement';
import AdWalletManagement from '../components/admin/AdWalletManagement';
import WebsiteShowcaseManagement from '../components/admin/WebsiteShowcaseManagement';

const AdminPanel = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [admin, setAdmin] = useState(null);

  useEffect(() => {
    const adminData = localStorage.getItem('admin');
    if (!adminData) {
      navigate('/admin');
      return;
    }
    setAdmin(JSON.parse(adminData));
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('admin');
    navigate('/');
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const tabs = [
    { id: 'overview', label: 'Overview', icon: LayoutDashboard },
    { id: 'crm', label: 'CRM Management', icon: Users },
    { id: 'page-analytics', label: 'Page Analytics', icon: PieChart },
    { id: 'sales-agents', label: 'Sales Agents', icon: UserCog },
    { id: 'users', label: 'Users', icon: Users },
    { id: 'orders', label: 'Orders', icon: Package },
    { id: 'payments', label: 'Payments', icon: DollarSign },
    { id: 'ads-payments', label: 'Ads Payments', icon: Flame },
    { id: 'ad-wallets', label: 'Ad Wallets', icon: Flame },
    { id: 'website-showcase', label: 'Website Showcase', icon: Globe },
    { id: 'wallets', label: 'Wallets', icon: Wallet },
    { id: 'utr', label: 'UTR Submissions', icon: FileText },
    { id: 'password-resets', label: 'Password Resets', icon: KeyRound },
    { id: 'contact', label: 'Contact Requests', icon: Phone },
    { id: 'payment-settings', label: 'Payment QR', icon: CreditCard },
    { id: 'package-settings', label: 'Pricing Packages', icon: Package },
    { id: 'coupons', label: 'Coupons & Offers', icon: Tag },
    { id: 'products-catalog', label: 'Onboarding Products', icon: Boxes },
    { id: 'sales-showcase', label: 'Sales Showcase', icon: Video },
    { id: 'reels', label: 'Landing Reels', icon: Film },
    { id: 'reviews', label: 'Client Reviews', icon: MessageSquare },
    { id: 'trust-badges', label: 'Trust Badges', icon: Award },
    { id: 'metrics-settings', label: 'Live Metrics', icon: TrendingUp },
    { id: 'ads', label: 'Ads Tracking', icon: BarChart3 },
    { id: 'analytics', label: 'User Analytics', icon: Settings },
    { id: 'earnings', label: 'Earnings', icon: Wallet },
    { id: 'onboarding', label: 'Onboarding', icon: ClipboardList },
    { id: 'client-onboarding', label: 'Client Onboarding Setups', icon: ShoppingBag },
    { id: 'site-videos', label: 'Homepage Videos', icon: Video },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'overview':
        return <AdminOverview />;
      case 'crm':
        return <CRMManagement />;
      case 'page-analytics':
        return <PageAnalyticsManagement />;
      case 'sales-agents':
        return <SalesAgentsManagement />;
      case 'users':
        return <UsersManagement />;
      case 'orders':
        return <OrdersManagement />;
      case 'payments':
        return <PaymentsManagement />;
      case 'ads-payments':
        return <AdsPaymentsManagement />;
      case 'ad-wallets':
        return <AdWalletManagement />;
      case 'website-showcase':
        return <WebsiteShowcaseManagement />;
      case 'wallets':
        return <WalletManagement />;
      case 'utr':
        return <UTRManagement />;
      case 'password-resets':
        return <PasswordResetsManagement />;
      case 'contact':
        return <ContactRequestsManagement />;
      case 'payment-settings':
        return <PaymentSettingsManagement />;
      case 'package-settings':
        return <PackageSettings />;
      case 'coupons':
        return <CouponsManagement />;
      case 'products-catalog':
        return <ProductsCatalogManagement />;
      case 'sales-showcase':
        return <SalesShowcaseManagement />;
      case 'reels':
        return <ReelsManagement />;
      case 'reviews':
        return <ReviewsManagement />;
      case 'trust-badges':
        return <TrustBadgesManagement />;
      case 'metrics-settings':
        return <MetricsSettings />;
      case 'ads':
        return <AdsManagement />;
      case 'analytics':
        return <AnalyticsManagement />;
      case 'earnings':
        return <EarningsManagement />;
      case 'onboarding':
        return <OnboardingManagement />;
      case 'client-onboarding':
        return <ClientOnboardingManagement />;
      case 'site-videos':
        return <SiteVideosManagement />;
      default:
        return <AdminOverview />;
    }
  };

  const activeTabObj = tabs.find((t) => t.id === activeTab) || tabs[0];
  const ActiveIcon = activeTabObj?.icon;

  const selectTab = (id) => {
    setActiveTab(id);
    setMobileMenuOpen(false);
    document.body.style.pointerEvents = '';
    window.scrollTo(0, 0);
  };

  if (!admin) {
    return null;
  }

  return (
    <div className="min-h-screen bg-slate-50 text-slate-800">
      {/* Header */}
      <header className="border-b border-slate-200 bg-white shadow-sm sticky top-0 z-40">
        <div className="container mx-auto px-3 sm:px-4 py-2.5 sm:py-4">
          <div className="flex items-center justify-between gap-2">
            <div className="flex items-center gap-2 sm:gap-4 min-w-0">
              <img
                src="/dropsquadz-logo.jpeg"
                alt="DropSquadz"
                className="w-9 h-9 sm:w-10 sm:h-10 rounded-full object-cover ring-2 ring-blue-500 flex-shrink-0"
              />
              <div className="min-w-0">
                <h1 className="text-lg sm:text-xl font-bold truncate bg-gradient-to-r from-blue-400 to-blue-700 bg-clip-text text-transparent">Admin Panel</h1>
                <p className="text-xs text-slate-500 hidden md:block">DropSquadz Management System</p>
              </div>
            </div>
            <div className="flex items-center gap-1 sm:gap-2 flex-shrink-0">
              <Button variant="ghost" size="sm" onClick={() => window.location.reload()}>
                <RefreshCw className="w-4 h-4" />
              </Button>
              <Button variant="ghost" size="sm" onClick={() => { localStorage.removeItem('admin'); navigate('/admin'); }}>
                <LogOut className="w-4 h-4" />
              </Button>
            </div>
          </div>
        </div>
        {/* Mobile section switcher */}
        <div className="md:hidden px-3 pb-2.5">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="w-full flex items-center justify-between gap-2 rounded-xl border border-blue-200 bg-blue-50 px-3 py-2.5 text-left"
            data-testid="admin-mobile-menu-btn"
          >
            <span className="flex items-center gap-2 min-w-0">
              {ActiveIcon && <ActiveIcon className="w-4 h-4 text-blue-600 flex-shrink-0" />}
              <span className="text-sm font-semibold text-blue-700 truncate">{activeTabObj?.label}</span>
            </span>
            <span className="flex items-center gap-1 text-xs text-blue-600 flex-shrink-0"><Menu className="w-4 h-4" /> All Sections</span>
          </button>
        </div>
      </header>

      {/* Desktop Navigation - Button Style */}
      <nav className="hidden md:block border-b border-slate-200 bg-gradient-to-b from-slate-50 to-white">
        <div className="container mx-auto px-4 py-4">
          <div className="grid grid-cols-3 lg:grid-cols-5 xl:grid-cols-7 2xl:grid-cols-8 gap-2">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              const isActive = activeTab === tab.id;
              return (
                <button
                  key={tab.id}
                  onClick={() => selectTab(tab.id)}
                  className={`group relative flex flex-col items-center justify-center gap-1.5 px-3 py-3 rounded-xl border-2 transition-all duration-200 text-center ${
                    isActive
                      ? 'bg-gradient-to-br from-blue-500 to-blue-600 border-blue-600 text-white shadow-lg shadow-blue-500/40 scale-[1.02]'
                      : 'bg-white border-slate-200 text-slate-700 hover:border-blue-400 hover:bg-blue-50/40 hover:shadow-md hover:-translate-y-0.5'
                  }`}
                  title={tab.label}
                >
                  <Icon className={`w-5 h-5 ${isActive ? 'text-white' : 'text-blue-600 group-hover:text-blue-700'}`} />
                  <span className={`text-[11px] font-semibold leading-tight line-clamp-2 ${isActive ? 'text-white' : 'text-slate-700'}`}>
                    {tab.label}
                  </span>
                  {isActive && (
                    <span className="absolute -top-1 -right-1 w-2.5 h-2.5 bg-yellow-400 rounded-full ring-2 ring-white animate-pulse" />
                  )}
                </button>
              );
            })}
          </div>
        </div>
      </nav>

      {/* Mobile Navigation Drawer */}
      <div className={`md:hidden fixed inset-0 bg-black/50 z-50 transition-opacity ${mobileMenuOpen ? 'opacity-100' : 'opacity-0 pointer-events-none invisible'}`} onClick={() => setMobileMenuOpen(false)}>
        <div className={`absolute left-0 top-0 bottom-0 w-[85vw] max-w-xs bg-white shadow-xl transition-transform flex flex-col ${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full'}`} onClick={(e) => e.stopPropagation()}>
          <div className="p-4 border-b border-slate-200 flex items-center justify-between">
            <h2 className="text-lg font-bold text-slate-800">Admin Menu</h2>
            <button onClick={() => setMobileMenuOpen(false)} className="p-2 hover:bg-slate-100 rounded-lg">
              <X className="w-5 h-5" />
            </button>
          </div>
          <div className="overflow-y-auto overscroll-contain flex-1 min-h-0 pb-6">
            {tabs.map((tab) => {
              const Icon = tab.icon;
              return (
                <button
                  key={tab.id}
                  onClick={() => selectTab(tab.id)}
                  data-testid={`admin-mobile-tab-${tab.id}`}
                  className={`w-full px-4 py-3 flex items-center space-x-3 transition-colors ${
                    activeTab === tab.id
                      ? 'bg-blue-50 text-blue-600 border-l-4 border-blue-600'
                      : 'text-slate-600 hover:bg-slate-50 border-l-4 border-transparent'
                  }`}
                >
                  <Icon className="w-5 h-5" />
                  <span className="text-sm font-medium">{tab.label}</span>
                </button>
              );
            })}
          </div>
        </div>
      </div>

      {/* Content */}
      <main key={activeTab} className="admin-main container mx-auto px-3 sm:px-4 py-4 sm:py-8 min-w-0" data-testid="admin-main">
        {renderContent()}
      </main>
    </div>
  );
};

export default AdminPanel;